import type { Tab } from 'modules/core/components/Card/types'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

export default function useLocationsTabs(id: number, spacesEnabled: boolean): Tab[] {
  const { navigation } = useNavigation()

  const defaultLocationsTabs = [
    {
      name: i18n.t('settings.locations.tabs.details'),
      index: false,
      href: navigation.settings.locations.locationsId.details.fullPath({ id }),
    },
    {
      name: i18n.t('settings.locations.tabs.employees'),
      index: false,
      href: navigation.settings.locations.locationsId.employees.fullPath({ id }),
    },
    {
      name: i18n.t('settings.locations.tabs.holidays'),
      index: false,
      href: navigation.settings.locations.locationsId.holidays.fullPath({ id }),
    },
  ]

  const workAreaTab = {
    name: i18n.t('settings.locations.tabs.work_areas'),
    index: true,
    href: navigation.settings.locations.locationsId.workAreas.fullPath({ id }),
  }

  const allLocationTabs = [...defaultLocationsTabs, workAreaTab]

  const tabs: Tab[] =
    hasFeature('dev_location_work_areas') || spacesEnabled ? allLocationTabs : defaultLocationsTabs

  return tabs
}
